const CLERK_FAPI = BUILD_CONFIG.CLERK_FAPI;

let cachedDevBrowserJwt: string | null = null;

async function initDevBrowser(): Promise<string | null> {
  // Production uses a custom domain — no dev browser needed
  if (!CLERK_FAPI.includes('accounts.dev')) {
    return null;
  }

  if (cachedDevBrowserJwt) {
    return cachedDevBrowserJwt;
  }

  const res = await fetch(`${CLERK_FAPI}/v1/dev_browser`, {
    method: 'POST',
    credentials: 'include',
  });

  if (!res.ok) {
    console.error('Failed to initialize Clerk dev browser');
    return null;
  }

  const data = await res.json();
  cachedDevBrowserJwt = data.token ?? null;
  return cachedDevBrowserJwt;
}

/**
 * Returns the cached dev browser JWT (or null).
 * Does NOT trigger initialization — call clerkFapiUrl first.
 */
export function getCachedDevBrowserJwt(): string | null {
  return cachedDevBrowserJwt;
}

/**
 * Returns a FAPI URL with __clerk_db_jwt appended for dev instances.
 * For production (custom domain), returns the plain URL.
 */
export async function clerkFapiUrl(path: string): Promise<string> {
  const jwt = await initDevBrowser();
  const url = new URL(`${CLERK_FAPI}${path}`);
  if (jwt) {
    url.searchParams.set('__clerk_db_jwt', jwt);
  }
  return url.toString();
}
